module.exports = __webpack_public_path__ + "static/media/end-bg.3ff12b3a.png";